import { WorkOrder } from "@/services/backend/vbs/work-orders/types/work-order";
import { useState } from "react";
import {
  UpdateBeginDateRequest,
  useVbsWorkOrderUpdateBeginDateMutation,
} from "@/services/backend/vbs/work-orders/api/work-order-api";
import { useDebouncedMutation } from "@/shared/lib/debounce/debounce";
import {
  errorsFor,
  useErrDocumentNotReady,
} from "@/shared/bsm/core/document/components/ui/err-document-not-ready";
import { fieldErrors } from "@/shared/lib/errors/validation-error";
import t from "@/lang/lang";
import { DateTimeInput } from "@/shared/components/form/datetime-input";

export function WorkOrderBeginDateInput({
  workOrder,
  disabled = false,
}: {
  workOrder: WorkOrder;
  disabled?: boolean;
}) {
  const [request, setRequest] = useState<UpdateBeginDateRequest>({
    id: workOrder.id,
    beginDate: workOrder.beginDate,
  });
  const mutation = useVbsWorkOrderUpdateBeginDateMutation();
  const { error } = useDebouncedMutation(request, setRequest, mutation, {
    id: workOrder.id,
    beginDate: workOrder.beginDate,
  });

  const { notReadyError, resetNotReadyErrorField } = useErrDocumentNotReady();

  const errors = [
    ...(errorsFor(notReadyError, "beginDate") ?? []),
    ...(fieldErrors(error, "beginDate") ?? []),
  ];

  return (
    <DateTimeInput
      label={t("Beginn der Arbeiten")}
      date={request.beginDate}
      onDateChange={(beginDate) => {
        setRequest({ ...request, beginDate: beginDate ?? "" });
        resetNotReadyErrorField("beginDate");
      }}
      errors={errors}
      disabled={disabled}
    />
  );
}
